import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  Input,
  Fab,
  Grid,
  Paper,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Button,
  InputLabel
} from '@material-ui/core';
import { connect } from 'react-redux';
import EditIcon from '@material-ui/icons/Edit';
import SelectReact from 'react-select';
import { UserType } from '../../validation';
import SaveCancelContainer from '../SaveCancelContainer';
import AgentsDetailsModal from '../AgentsDetailsModal';

import i18n from '../../i18n';

import {
  formatDateOnlyString,
  groupAgents,
} from '../../helpers/helpers';
import {
  fetchAgencies,
  fetchAgents,
  fetchOrigins,
  fetchPositions,
  updateEmployeeProfile,
} from '../../helpers/externalRequests';
import {
  findAgentOptions,
} from '../../helpers/optionFormatters';
import countryCodes from '../../constants/countryCodes';

import '../../assets/stylesheets/EmployeeAttributes.css';
import RequireScope from '../RequireScope';

class EmployeeAttributes extends Component {
  constructor(props) {
    super(props);

    const { employee } = this.props;

    const {
      id,
      firstName,
      lastName,
      nickName,
      email,
      phoneNumber,
      isActive,
      isPOPreApproved,
      isFullTime,
      isContractor,
      positions,
      primaryPositionId,
      agents,
      nationalities,
      updatedAt
    } = employee;

    const positionNames = positions.map(position =>
      i18n.t(`positions:${position.positionName}`)
    );

    const nationalityNames = nationalities.map(nationality =>
      i18n.t(`country:${nationality}`)
    );

    const agentIds = agents.length ? agents.map(agent => agent.id) : [];

    this.state = {
      inEditMode: false,
      id,
      firstName,
      lastName,
      nickName: nickName || i18n.t('noData'),
      email,
      Home: phoneNumber ? phoneNumber.Home : i18n.t('noData'),
      Work: phoneNumber ? phoneNumber.Work : i18n.t('noData'),
      // TODO get and use main number from key
      // mainNumber: phoneNumber ? phoneNumber._main : i18n.t('noData'),
      isActive,
      isPOPreApproved,
      isFullTime,
      isContractor,
      agentIds,
      originOptions: [],
      nationalityOptions: [],
      positions: positionNames,
      primaryPositionId,
      nationalityNames,
      updatedAt,
      agentModal: false,
      editErrors: {},
      saving: false
    };

    this.baseState = this.state;
  }

  componentDidMount() {
    const { 
      employee: {
        origins
      } 
    } = this.props;
    const { positions, nationalityNames } = this.state; 
    Promise
      .all([
        fetchOrigins(),
        fetchPositions(),
        fetchAgencies(),
        fetchAgents()
      ])
      .then(
        ([allOrigins, allPositions, agencies, agents]) => {
          const originOptions = this.generateOriginsOptions(allOrigins.data.origins);
          const nationalityOptions = this.generateNationalitiesOptions();
          const positionOptions = this.generatePositionsOptions(
            allPositions.data
          );
          const groupedAgents = groupAgents(
            agencies.data,
            agents.data.map(this.mapAgentEntities)
          );
          // TODO filter by value, not label
          const selectedOriginOptions = originOptions.filter(option =>
            origins.includes(option.label)
          );
          const selectedNationalityOptions = nationalityOptions.filter(option =>
            nationalityNames.includes(option.label)
          );
          const selectedPositionOptions = positionOptions.filter(option =>
            positions.includes(option.label)
          );
          this.setState(
            {
              groupedAgents,
              originOptions,
              nationalityOptions,
              positionOptions,
              selectedOriginOptions,
              selectedNationalityOptions,
              selectedPositionOptions
            },
            () => this.setBaseState()
          );
        }
      );
  }

  agentModal = () => {
    this.setState({ agentModal: true });
  };
  
  hideAgentModal = () => {
    this.setState({ agentModal: false });
  };

  setBaseState = () => {
    this.baseState = this.state;
  };

  mapAgentEntities = agent => {
    return {
      ...agent,
      name: `${agent.firstName} ${agent.lastName}`,
      label: `${agent.firstName} ${agent.lastName}`,
      value: agent.id,
      isSelected: false
    };
  };

  handleAgentChange = event => {
    this.setState({ agentIds: event ? event.map(value => value.id) : [] });
  };

  handleChange = event => {
    this.setState({ [event.currentTarget.name]: event.target.value });
  };

  handleCheckboxToggle = (checkboxName, value) => {
    switch (checkboxName) {
      case 'isFullTime':
        if (!value) {
          this.setState({ isContractor: value, isFullTime: value });
        } else {
          this.setState({ isFullTime: value });
        }
        break;
      case 'isContractor':
        if (value) {
          this.setState({ isContractor: value, isFullTime: value });
        } else {
          this.setState({ isContractor: value });
        }
        break;
      default:
        this.setState({ [checkboxName]: value });
        break;
    }
  };

  toggleEditForm = () => {
    const { nickName } = this.state;
    const editNickName = nickName === i18n.t('noData') ? '' : nickName;
    this.setState(prevstate => ({
      inEditMode: !prevstate.inEditMode,
      nickName: editNickName
    }));
  };

  handleSubmitForm = async () => {
    const {
      id,
      firstName,
      lastName,
      nickName,
      email,
      Home,
      Work,
      agentIds,
      selectedOriginOptions,
      selectedNationalityOptions,
      selectedPositionOptions,
      isActive,
      isPOPreApproved,
      isFullTime,
      isContractor,
      primaryPositionId
    } = this.state;

    const editNickName = nickName === '' ? null : nickName;

    const {
      getEmployee,
      displaySnackbar
    } = this.props;

    try {
      await updateEmployeeProfile({
        id,
        firstName,
        lastName,
        nickName: editNickName,
        email,
        Home,
        Work,
        agentIds,
        selectedOriginOptions,
        selectedNationalityOptions,
        selectedPositionOptions,
        isActive,
        isPOPreApproved,
        isFullTime,
        isContractor,
        primaryPositionId
      });
      getEmployee(id);
      displaySnackbar(i18n.t('userProfile:editSuccess'));
      this.setState(
        { inEditMode: false, editErrors: {}, saving: false },
        () => this.setBaseState()
      );
    } catch (error) {
      const msg = (error?.response?.data?.message) || error.message;
        displaySnackbar(`${i18n.t('userProfile:editError')} ${msg}`);
        this.baseState.saving = false;
        this.cancelForm();
    }
  }

  submitForm = () => {
    this.setState({ saving: true }, () => this.handleSubmitForm());
  };

  cancelForm = () => {
    this.setState(this.baseState);
  };

  generateOriginsOptions = elements => {
    return elements.map(element => {
      return {
        label: element.originName,
        value: element.id
      };
    });
  };

  generatePositionsOptions = elements => {
    return elements.map(element => {
      return {
        label: i18n.t(`positions:${element.name}`),
        value: element.id,
        isDisabled: !element.isActive,
      };
    });
  };

  generateNationalitiesOptions = () => {
    return countryCodes.map(countryCode => {
      return {
        label: i18n.t(`country:${countryCode}`),
        value: countryCode
      };
    });
  };

  determinePrimaryPosition = (incomingPrimaryPositionId) => {
    const { positionOptions } = this.state;
    if (positionOptions === undefined) {
      return null;
    }
    return incomingPrimaryPositionId
      ? positionOptions.find(position => position.value === incomingPrimaryPositionId).label
      : null;
  };

  handleSelectorChange = (event, name) => {
    // event is the array of currently-selected values
    // name.name is the name of the caller
    this.setState({
      [`selected${name.name}`]: event
    });
  };

  handlePositionChange = (event, name) => {
    const stateField = `selected${name.name}`;
    this.setState(prevState => {
      if (event === null) {
        return {
          [stateField]: event,
          primaryPositionId: event
        };
      }
      if (!prevState.primaryPositionId) {
        const primaryPositionId = event.length ? event[0].value : null;
        return {
          [stateField]: event,
          primaryPositionId
        };
      } 
      if (event.length) {
        const matchingPosition = event.find(
          option => option.value === prevState.primaryPositionId
        );
        const primaryPositionId = !matchingPosition
          ? event[0].value
          : prevState.primaryPositionId;

        return {
          [stateField]: event,
          primaryPositionId
        };
      }
      return {
        [stateField]: null,
        primaryPositionId: null
      };
    });
  };

  handlePrimaryPositionChange = selectedItem => {
    if (selectedItem) {
      this.setState({ primaryPositionId: selectedItem.value });
    }
  };

  render() {
    const {
      agentIds,
      inEditMode,
      firstName,
      lastName,
      nickName,
      editErrors,
      email,
      Home,
      Work,
      isActive,
      isFullTime,
      isContractor,
      isPOPreApproved,
      originOptions,
      nationalityOptions,
      primaryPositionId,
      updatedAt,
      groupedAgents,
      positionOptions,
      selectedOriginOptions,
      selectedNationalityOptions,
      selectedPositionOptions,
      agentModal,
      saving,
    } = this.state;

    const { user, employee } = this.props;

    const displayPrimaryPosition = this.determinePrimaryPosition(
      primaryPositionId
    );

    return (
      <>
        <Paper className="employeeAttributesContainer">
          <Grid container>
            <RequireScope scopes={['employees:write']}>
              {!inEditMode && (
                <Grid item xs={1}>
                  <h3>
                    <Fab
                      className="editButton"
                      variant="extended"
                      size="small"
                      color="primary"
                      aria-label="edit"
                      onClick={this.toggleEditForm}
                    >
                      <EditIcon color="secondary" />
                    </Fab>
                  </h3>
                </Grid>
              )}
            </RequireScope>
            <Grid item xs={11}>
              <h3>{`${firstName} ${lastName}`}</h3>
              <h5>
                {// display primary position
                  displayPrimaryPosition
                    ? i18n.t(`positions:${displayPrimaryPosition}`)
                    : i18n.t('userProfile:noPosition')}
              </h5>
            </Grid>
            <Grid item xs={12}>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell className="attributeLabel">
                      {i18n.t('firstName')}
                    </TableCell>
                    <TableCell>
                      <Input
                        className="attributeValue"
                        name="firstName"
                        value={firstName}
                        onChange={this.handleChange}
                        disabled={!inEditMode || saving}
                        disableUnderline={!inEditMode}
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="attributeLabel">
                      {i18n.t('lastName')}
                    </TableCell>
                    <TableCell>
                      <Input
                        className="attributeValue"
                        name="lastName"
                        value={lastName}
                        onChange={this.handleChange}
                        disabled={!inEditMode || saving}
                        disableUnderline={!inEditMode}
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="attributeLabel">
                      {i18n.t('preferredName')}
                    </TableCell>
                    <TableCell>
                      <Input
                        className="attributeValue"
                        name="nickName"
                        value={nickName}
                        onChange={this.handleChange}
                        disabled={!inEditMode || saving}
                        disableUnderline={!inEditMode}
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="attributeLabel">
                      {i18n.t('emailAddress')}
                    </TableCell>
                    <TableCell>
                      {editErrors.existingEmail && (
                        <InputLabel error>
                          {i18n.t('existingEmail', {
                            email: editErrors.existingEmail
                          })}
                        </InputLabel>
                      )}
                      <Input
                        className="attributeValue"
                        name="email"
                        value={email}
                        onChange={this.handleChange}
                        disabled={!inEditMode || saving}
                        disableUnderline={!inEditMode}
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="attributeLabel">
                      {i18n.t('Home')}
                    </TableCell>
                    <TableCell>
                      <Input
                        className="attributeValue"
                        name="Home"
                        value={Home}
                        onChange={this.handleChange}
                        disabled={!inEditMode || saving}
                        disableUnderline={!inEditMode}
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="attributeLabel">
                      {i18n.t('Work')}
                    </TableCell>
                    <TableCell>
                      <Input
                        className="attributeValue"
                        name="Work"
                        value={Work}
                        onChange={this.handleChange}
                        disabled={!inEditMode || saving}
                        disableUnderline={!inEditMode}
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="attributeLabel">
                      {i18n.t('positions')}
                    </TableCell>
                    <TableCell>
                      {editErrors.bookedPosition && (
                        <InputLabel error>
                          {i18n.t('bookedPosition', {
                            positions: editErrors.bookedPosition
                              .map(
                                positionId =>
                                  positionOptions[positionId - 1]
                                    .label
                              )
                              .toString()
                          })}
                        </InputLabel>
                      )}
                      <SelectReact
                        name="PositionOptions"
                        isDisabled={!inEditMode || saving}
                        isMulti
                        hideSelectedOptions
                        menuPlacement="auto"
                        value={selectedPositionOptions}
                        options={positionOptions}
                        onChange={this.handlePositionChange}
                      />
                    </TableCell>
                  </TableRow>
                  {selectedPositionOptions && selectedPositionOptions.length ? (
                    <TableRow>
                      <TableCell className="attributeLabel">
                        {i18n.t('primaryPosition')}
                      </TableCell>
                      <TableCell>
                        <SelectReact
                          menuPlacement="auto"
                          isDisabled={!inEditMode || saving}
                          value={
                            primaryPositionId
                              ? positionOptions.find(
                                position =>
                                  position.value === primaryPositionId
                              ).label
                              : null
                          }
                          options={selectedPositionOptions}
                          onChange={this.handlePrimaryPositionChange}
                          placeholder={displayPrimaryPosition}
                        />
                      </TableCell>
                    </TableRow>
                  ) : null}
                  <TableRow>
                    <TableCell className="attributeLabel">
                      {i18n.t('isFullTime')}
                    </TableCell>
                    <TableCell>
                      <FormGroup row>
                        <FormControlLabel
                          disabled={!inEditMode || saving}
                          control={
                            <Checkbox
                              checked={isFullTime}
                              color="secondary"
                              onChange={() =>
                                this.handleCheckboxToggle(
                                  'isFullTime',
                                  !isFullTime
                                )
                              }
                            />
                          }
                        />
                      </FormGroup>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="attributeLabel">
                      {i18n.t('isContractor')}
                    </TableCell>
                    <TableCell>
                      <FormGroup row>
                        <FormControlLabel
                          disabled={!inEditMode || saving}
                          control={
                            <Checkbox
                              checked={isContractor}
                              color="secondary"
                              onChange={() =>
                                this.handleCheckboxToggle(
                                  'isContractor',
                                  !isContractor
                                )
                              }
                            />
                          }
                        />
                      </FormGroup>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="attributeLabel">
                      {i18n.t('agents')}
                    </TableCell>
                    <TableCell>
                      <SelectReact
                        isMulti
                        fullWidth
                        value={
                          groupedAgents
                            ? findAgentOptions(groupedAgents, agentIds)
                            : null
                        }
                        isDisabled={!inEditMode || saving}
                        hideSelectedOptions
                        menuShouldScrollIntoView={false}
                        className="bookingSelectField"
                        options={groupedAgents}
                        onChange={this.handleAgentChange}
                      />
                    </TableCell>
                  </TableRow>
                  {employee.agents.length > 0 && (
                    <TableRow>
                      <TableCell className="attributeLabel">
                        {i18n.t('agents:agentDetails')}
                      </TableCell>
                      <TableCell>
                        <Button
                          className="ssenseButton ssenseSecondary"
                          onClick={this.agentModal}
                        >
                          {i18n.t('agents:agentDetails')}
                        </Button>
                      </TableCell>
                    </TableRow>
                  )}
                  <TableRow>
                    <TableCell className="attributeLabel">
                      {i18n.t('booking:nationalities')}
                    </TableCell>
                    <TableCell>
                      <SelectReact
                        name="NationalityOptions"
                        isDisabled={!inEditMode || saving}
                        isMulti
                        hideSelectedOptions
                        menuPlacement="auto"
                        value={selectedNationalityOptions}
                        options={nationalityOptions}
                        onChange={this.handleSelectorChange}
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="attributeLabel">
                      {i18n.t('booking:origins')}
                    </TableCell>
                    <TableCell>
                      <SelectReact
                        name="OriginOptions"
                        isDisabled={!inEditMode || saving}
                        isMulti
                        hideSelectedOptions
                        menuPlacement="auto"
                        value={selectedOriginOptions}
                        options={originOptions}
                        onChange={this.handleSelectorChange}
                      />
                    </TableCell>
                  </TableRow>
                  <RequireScope scopes={['po-pre-approved:read']}>
                    <TableRow>
                      <TableCell className="attributeLabel">
                        {i18n.t('isPOPreApproved')}
                      </TableCell>
                      <TableCell>
                        <FormGroup row>
                          <FormControlLabel
                            disabled={!user.scopes.includes('po-pre-approved:write') || !inEditMode || saving}
                            control={
                              <Checkbox
                                checked={isPOPreApproved}
                                color="secondary"
                                onChange={() =>
                                  this.handleCheckboxToggle('isPOPreApproved', !isPOPreApproved)
                                }
                              />
                            }
                          />
                        </FormGroup>
                      </TableCell>
                    </TableRow>
                  </RequireScope>
                  <TableRow>
                    <TableCell className="attributeLabel">
                      {i18n.t('isActive')}
                    </TableCell>
                    <TableCell>
                      <FormGroup row>
                        <FormControlLabel
                          disabled={!inEditMode || saving}
                          control={
                            <Checkbox
                              checked={isActive}
                              color="secondary"
                              onChange={() =>
                                this.handleCheckboxToggle('isActive', !isActive)
                              }
                            />
                          }
                        />
                      </FormGroup>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
              {inEditMode && (
                <SaveCancelContainer
                  onSave={this.submitForm}
                  onCancel={this.cancelForm}
                  saving={saving}
                />
              )}
            </Grid>
          </Grid>
          <AgentsDetailsModal
            showModal={agentModal}
            onClose={this.hideAgentModal}
            agents={employee.agents}
          />
        </Paper>
        <p>
          {`${i18n.t('userProfile:lastUpdated')} ${formatDateOnlyString(
            new Date(updatedAt)
          )}`}
        </p>
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
});

EmployeeAttributes.propTypes = {
  employee: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
      PropTypes.array,
      PropTypes.number,
      PropTypes.bool
    ])
  ).isRequired,
  getEmployee: PropTypes.func.isRequired,
  displaySnackbar: PropTypes.func.isRequired,
  user: UserType.isRequired
};

export { EmployeeAttributes as EmployeeAttributesNoConnect }
export default connect(mapStateToProps)(EmployeeAttributes);
